export default "__VITE_ASSET__b6d5ccc3__"